import Head from 'next/head'

const TrustPilot_New = ({
  widgetHeight = "500px",
}) => {
  
  return (
    <>
      <Head>
        <script type="text/javascript" src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"></script>
      </Head>
      {/* <ReactPlaceholder showLoadingAnimation ready={ready} type="rect"> */}
      <div className="trustpilot-widget container mt-5" data-locale="en-US" data-template-id="539adbd6dec7e10e686debee" data-businessunit-id="63ce673f7ec124282d18a6b4" data-style-height={widgetHeight} data-style-width="100%" data-theme="light" data-stars="4,5" data-review-languages="en">
        <a href="https://www.trustpilot.com/review/joinnextmed.com" target="_blank" rel="noopener"></a>
      </div>
      {/* </ReactPlaceholder> */}
    </>
  )
}

export default TrustPilot_New


